import {feathers} from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import authenticationClient from '@feathersjs/authentication-client'
import {io} from 'socket.io-client'

const ioOptions = {
  transports: ['websocket'],
  upgrade: false,
}

const socket = io(process.env.REACT_APP_API_URI || '', ioOptions)

const client = feathers()

client.configure(socketio(socket))
client.configure(authenticationClient({
  storage: window.localStorage,
}))


export default client
